<template>
  <div :class="AgentIsShow == true ? 'container' : 'settingContainer'">
    <van-cell-group>
      <van-cell style="height: 86px; display: flex; align-items: center">
        <!-- 使用 title 插槽来自定义标题 -->
        <template #title>
          <div class="flex">
            <span class="custom-title avarTitle">头像</span>
            <div style="width: 54px; height: 54px">
              <img
                :src="userInfo.avatarUrl"
                alt=""
                style="width: 100%; height: 100%; border-radius: 50%"
              />
            </div>
          </div>
        </template>
        <template #right-icon>
          <image-crop
            :uploadLoading="uploadLoading"
            @before-upload="beforeRead"
            @after-upload="cropUpload"
          ></image-crop>
        </template>
        <template #default> </template>
      </van-cell>
      <van-cell
        @click="onEditNickName"
        title-class="cellTitle"
        value-class="cellValue"
      >
        <!-- 使用 title 插槽来自定义标题 -->
        <template #title>
          <span class="custom-title">昵称</span>
          <span>{{ userInfo.nickName }}</span>
        </template>
        <template #default>
          <span>修改昵称</span>
        </template>
        <template #right-icon>
          <i
            class="van-icon van-icon-arrow van-cell__right-icon"
            style="height: 34px; line-height: 34px"
          ></i>
        </template>
      </van-cell>
      <van-cell v-if="userInfo.phoneNumber">
        <!-- 使用 title 插槽来自定义标题 -->
        <template #title>
          <span style="margin-right: 32px">手机号</span>
          <span>{{
            userInfo.phoneNumber ? userInfo.phoneNumber : phoneNumber
          }}</span>
        </template>
      </van-cell>
      <van-cell
        title="手机号"
        v-if="!userInfo.phoneNumber"
        @click="onPhoneNumberClick"
      >
        <template #right-icon>
          <i
            class="van-icon van-icon-arrow van-cell__right-icon"
            style="height: 34px; line-height: 34px"
          ></i>
        </template>
      </van-cell>
      <!--   -->
      <van-cell
        title="找回账号"
        v-if="
          userInfo.userType == 'common' &&
          (userInfo.statusName == 'normal' || 'limited')
        "
        is-link
        @click="onClickEdit"
      >
        <template #right-icon>
          <i
            class="van-icon van-icon-arrow van-cell__right-icon"
            style="height: 34px; line-height: 34px"
          ></i>
        </template>
      </van-cell>
      <!-- <van-cell
        title="分享码"
        v-if="userInfo.shareCode ? userInfo.shareCode : shareCode"
       
        @click="onShareCode"
      /> -->
      <van-cell title="清除缓存" is-link @click="onClear">
        <template #right-icon>
          <i
            class="van-icon van-icon-arrow van-cell__right-icon"
            style="height: 34px; line-height: 34px"
          ></i>
        </template>
      </van-cell>
    </van-cell-group>
    <van-dialog
      v-model="phoneShow"
      showCancelButton
      confirmButtonText="确定"
      cancelButtonText="取消"
      confirm-button-color="#ee0a24"
      @confirm="onSubmit(user)"
    >
      <div class="vanGroup">
        <van-field
          label-width="15vw"
          v-model="user.phoneNumber"
          type="tel"
          placeholder="请输入手机号"
          clearable
          label="手机号"
          maxlength="30"
          :value="user.phoneNumber"
        ></van-field>
        <!-- <van-field
          label-width="15vw"
          v-model="user.code"
          center
          clearable
          type="number"
          label="验证码"
          placeholder="请输入验证码"
          @input="changeauthCd"
        >
          <template #button>
            <button
              slot="button"
              :disabled="!countdown"
              v-bind:class="[countdown ? 'reg_active' : 'reg_disActive']"
              @click="getCode"
            >
              <span v-if="countdown">{{ text }}</span>
              <span v-if="!countdown">{{ text }} ({{ count }})</span>
            </button>
          </template>
        </van-field> -->
      </div>
    </van-dialog>
    <van-dialog
      v-model="IsEdituser"
      showCancelButton
      confirmButtonText="确定"
      cancelButtonText="取消"
      confirm-button-color="#ee0a24"
      @confirm="onEditSubmit(Edituser)"
      @cancel="onEditCancel"
    >
      <div class="vanGroup">
        <van-field
          label-width="15vw"
          v-model="Edituser.phoneNumber"
          type="tel"
          placeholder="请输入手机号"
          clearable
          maxlength="30"
          label="手机号"
          :value="Edituser.phoneNumber"
        ></van-field>
        <!-- <van-field
          label-width="15vw"
          v-model="Edituser.sms"
          center
          clearable
          type="number"
          label="验证码"
          placeholder="请输入验证码"
          @input="changeauthCd"
        >
          <template #button>
            <button
              slot="button"
              :disabled="!Editcountdown"
              v-bind:class="[Editcountdown ? 'reg_active' : 'reg_disActive']"
              @click="getSms(Edituser)"
            >
              <span v-if="Editcountdown">{{ EditText }}</span>
              <span v-if="!Editcountdown"
                >{{ EditText }} ({{ EditCount }})</span
              >
            </button>
          </template>
        </van-field> -->
      </div>
    </van-dialog>
    <van-dialog
      v-model="IsIDCard"
      showCancelButton
      confirmButtonText="确定"
      cancelButtonText="取消"
      confirm-button-color="#ee0a24"
      @confirm="onIDCardSubmit(EditIDCard)"
    >
      <div class="vanGroup">
        <van-field
          label-width="15vw"
          v-model="EditIDCard.phoneNumber"
          type="tel"
          placeholder="请输入手机号"
          clearable
          maxlength="30"
          label="手机号"
          :value="EditIDCard.phoneNumber"
        ></van-field>
        <van-field
          label-width="15vw"
          v-model="EditIDCard.IDCard"
          center
          clearable
          label="身份证"
          placeholder="请输入身份证"
        >
        </van-field>
      </div>
    </van-dialog>
    <van-dialog
      v-model="IsShowEdit"
      showCancelButton
      confirmButtonText="确定"
      cancelButtonText="取消"
      confirm-button-color="#ee0a24"
      :before-close="onBeforeClose"
    >
      <div class="editNickName">
        <div class="vanNickName">修改昵称</div>
        <div
          :class="
            errMess == true || errMessNickName == true
              ? 'mess'
              : 'errMessHeight'
          "
        >
          <van-field
            label-width="15vw"
            v-model="settingUer.nickName"
            :value="settingUer.nickName"
            clearable
            :maxlength="16"
            @input="onInputNickName"
            :border="false"
          >
          </van-field>
        </div>

        <!--  -->
        <div class="redMess" v-if="errMess">请输入汉字、英文或数字</div>
        <div class="redMess" v-if="errMessNickName">请输入昵称</div>
      </div>
    </van-dialog>
    <van-overlay :show="isLoading">
      <div class="wrapper">
        <loading v-if="isLoading == true"></loading>
      </div>
    </van-overlay>
    <!-- <van-dialog
      v-model="codeShow"
      showCancelButton
      confirmButtonText="确定"
      cancelButtonText="取消"
      confirm-button-color="#ee0a24"
      @confirm="confirm"
    >
      <div class="vanGroup">
        <van-field
          v-model="user.shareCode"
          placeholder="请输入分享码"
          clearable
          label="分享码"
          :value="user.shareCode"
        ></van-field>
      </div>
    </van-dialog> -->
    <!-- <div>
      <van-overlay :show="shareCodeShow">
        <div class="van-group" style="position: relative">
          <div class="overlayContent" style="position: absolute">
            <div class="overlayCode">恭喜获得{{getCodeNum}}个优惠码</div>
            <button class="button" @click="shareCodeConfirm">确认</button>
            <span>请在2021年12月30日之前使用</span>
          </div>
          <div class="close" @click="shareCodeShow = false">
            <van-icon name="cross" />
          </div>
        </div>
        <div class="pyro">
          <div class="before"></div>
          <div class="after"></div>
        </div>
      </van-overlay>
    </div> -->
  </div>
</template>

<script>
import loading from "../../components/loading/loading";
import { mapGetters, mapActions } from "vuex";
import { Cell, CellGroup, Field, Dialog, Toast, Overlay, Icon } from "vant";
import service from "../../api/setting/index.js";
import serviceRefresh from "../../api/redirect/index";
import imageCrop from "../../components/imageCrop.vue";
export default {
  components: {
    imageCrop,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Dialog.Component.name]: Dialog.Component,
    [Toast.name]: Toast,
    [Overlay.name]: Overlay,
    [Icon.name]: Icon,
    loading,
  },
  data() {
    return {
      isLoading: true, //loading状态
      errMess: false,
      errMessNickName: false,
      IsShowEdit: false, //编辑昵称
      getCodeNum: "",
      IsIDCard: false,
      phoneShow: false,
      codeShow: false,
      user: {
        phoneNumber: "",
        // code: "",
        shareCode: "",
      },

      IsEdituser: false,
      EditIDCard: {
        phoneNumber: "",
        IDCard: "",
        openId: "",
      },
      settingUer: {
        nickName: "",
      },
      Edituser: {
        phoneNumber: "",
        // sms: "",
        openId: "",
      },
      phoneNumber: "",
      password: "",
      nickName: "",
      avatarUrl: "",
      shareCode: "",
      submit: {
        shareCode: "",
        phoneNumber: "",
      },
      verificationCode: "",
      countdown: true,
      count: "",
      timer: null,
      text: "发送验证码",
      Editcountdown: true,
      EditText: "发送验证码",
      EditCount: "",
      EditTimer: null,
      rules: {},
      ruleForm: {},
      loading: false,
      visible: false,
      uploadLoading: false,
      url: "",
      option: {
        outputSize: 0.1,
        info: false, // 裁剪框的大小信息
        outputType: "jpeg", // 裁剪生成图片的格式
        canScale: false, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: window.innerWidth - 100 + "px", // 默认生成截图框宽度
        autoCropHeight: window.innerWidth - 100 + "px", // 默认生成截图框高度
        high: true, // 是否按照设备的dpr 输出等比例图片
        fixedBox: true, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [1, 1], // 截图框的宽高比例
        full: true, // 是否输出原图比例的截图
        canMoveBox: false, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: false, // 截图框是否被限制在图片里面
        infoTrue: false, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
        mode: "100% auto", // 图片默认渲染方式
      },
    };
  },
  computed: {
    ...mapGetters(["userInfo", "agentShow"]),
    AgentIsShow() {
      return this.agentShow == null ? false : this.agentShow.isShow;
    },
  },

  mounted() {
    this.shareCode = this.$route.query.shareCode;
    this.init();
    let userInfo = this.userInfo;
    if (!userInfo || !userInfo.token || !userInfo.isLogin) {
      Dialog.alert({
        message: "请先登录账号",
      }).then(() => {
        this.$router.replace({
          path: "/login",
          query: { redirect: this.$router.currentRoute.fullPath }, // 将跳转的路由path作为参数，登录成功后跳转到该路由
        });
      });
    }
    if (this.shareCode) {
      this.show = true;
    }
  },
  methods: {
    ...mapActions(["wxLogin", "buyAgentStatus"]),
    init() {
      service
        .getUserInfo()
        .then((res) => {
          if (res.statusCode == 200) {
            let dateTime = new Date().getTime();
            let settingUserInfo = this.userInfo;
            settingUserInfo.nickName = res.data.userName;
            settingUserInfo.avatarUrl = res.data.avatarUrl + "?" + dateTime;
            settingUserInfo.identityType = settingUserInfo.userType;
            settingUserInfo.identityStatus = settingUserInfo.statusName;
            this.wxLogin(settingUserInfo).then(() => {});
          } else {
            this.$toast(res.errors);
          }
        })
        .catch((err) => {
          this.$toast(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    onEditNickName() {
      this.settingUer.nickName = JSON.parse(
        JSON.stringify(this.userInfo.nickName)
      );
      this.IsShowEdit = true;
    },
    // 编辑昵称
    onInputNickName(e) {
      var reg = /^[0-9a-zA-Z\u4E00-\u9FA5]+$/;
      console.log(e, e.length, 395);
      if (e.trim() == "") {
        this.errMessNickName = true;
        this.errMess = false;
        return;
      } else {
        this.errMessNickName = false;
      }
      if (!reg.test(e)) {
        this.errMess = true;
        this.errMessNickName = false;
      } else {
        this.errMess = false;
      }
    },
    onBeforeClose(action, done) {
      var reg = /^[0-9a-zA-Z\u4E00-\u9FA5]+$/;
      this.isLoading = true;
      if (action === "confirm") {
        if (this.settingUer.nickName.trim() == "") {
          this.errMessNickName = true;
          this.errMess = false;
          this.isLoading = false;

          done(false);
          Toast("请输入昵称");
          return;
        } else {
          this.errMessNickName = false;
        }
        if (!reg.test(this.settingUer.nickName)) {
          this.errMess = true;
          this.errMessNickName = false;
          this.isLoading = false;
          done(false);
          Toast("请输入汉字、英文或数字");
        } else {
          this.errMess = false;
          this.IsShowEdit = true;
          this.isLoading = true;
          service
            .updateUserName(this.settingUer.nickName)
            .then((res) => {
              if (res.statusCode == 200) {
                Toast("昵称修改成功");
                this.IsShowEdit = false;
                setTimeout(() => {
                  this.isLoading = false;
                }, 1000);
                done(true);
                this.init();
              } else {
                this.$toast(res.errors);
                this.IsShowEdit = true;
                setTimeout(() => {
                  this.isLoading = false;
                }, 700);
                return done(false);
              }
            })
            .catch((err) => {
              Toast(err);
              this.IsShowEdit = true;

              return done(false);
            })
            .finally(() => {
              setTimeout(() => {
                this.isLoading = false;
              }, 700);
            });
        }
      } else {
        this.isLoading = false;
        this.errMess = false;
        this.errMessNickName = false;
        done(true); //关闭弹窗, true可以省略
      }
    },

    beforeRead(file, callback) {
      const isImgType =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg";

      if (!isImgType) {
        this.$toast("上传图片只能是 JPG或PNG 格式!");
        callback(false);
        return false;
      }
      callback(true);
      return true;
    },
    // 裁剪点击确定
    cropUpload(file) {
      this.isLoading = true;
      // this.uploadLoading = true;
      // const isLt2M = file.size / 1024 / 1024 < 2;
      const max_size = 200;
      if (file.size > max_size * 1024) {
        this.$toast("图片过大，请重新上传");
        this.isLoading = false;
        return false;
      }
      // if (!isLt2M) {
      //   this.$toast("上传图片大小不能超过 2MB!");
      //   this.isLoading = false
      //   return false;
      // }
      this.ruleForm.whitePhoneUrl = file;
      var formdata = new FormData();
      formdata.append("formfile", file);
      service
        .UploadUserImage(formdata)
        .then((res) => {
          if (res.statusCode == 200) {
            let dateTimer = new Date().getTime();
            this.uploadLoading = false;
            // this.$router.go(0)
            this.ruleForm.whitePhotoId = res.data;
            let settingUserInfo = this.userInfo;
            settingUserInfo.avatarUrl = res.data + "?" + dateTimer;
            console.log(settingUserInfo.avatarUrl, "settingUserInfo.avatarUrl");
            settingUserInfo.identityType = settingUserInfo.userType;
            settingUserInfo.identityStatus = settingUserInfo.statusName;
            this.wxLogin(settingUserInfo).then(() => {});
            Toast("头像修改成功");
          } else {
            this.uploadLoading = false;
            this.$toast(res.errors);
          }
        })
        .catch((err) => {
          this.$toast(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    delImgId(file) {
      this.ruleForm.whitePhotoId = "";
      this.ruleForm.whitePhoneUrl = "";
      return true;
    },
    // 清除缓存
    onClear() {
      localStorage.removeItem("__cartinfo__");
      localStorage.removeItem("__userinfo__");
      this.buyAgentStatus({ show: false });
      Toast("缓存成功,请重新登录");
      this.$router.replace("login");
    },
    // 验证码不能超过6位
    changeauthCd() {
      if (this.user.code.length > 6) {
        this.user.code = this.user.code.slice(0, 6);
        Toast("验证码不能超过6位");
      }
      if (this.Edituser.sms.length > 6) {
        this.Edituser.sms = this.Edituser.sms.slice(0, 6);
        Toast("验证码不能超过6位");
      }
    },
    // 换绑手机号
    onClickEdit() {
      this.IsEdituser = true;
    },
    //点击验证码
    getCode(e) {
      // var reg = /^(1[0-9])\d{9}$/;
      var reg = /^(\d{8,30})$/;
      if (!reg.test(this.user.phoneNumber)) {
        Toast("请输入正确的电话号码");
        return;
      }
      console.log(this.user.phoneNumber, 6666666666666);
      const TIME_COUNT = 60;
      console.log(this.timer, 253);
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.countdown = false;
        this.text = "重新发送";
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.countdown = true;

            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
        service
          .code({
            phoneNumber: this.user.phoneNumber,
            code: "",
          })
          .then((res) => {
            if (res.statusCode == 200) {
              Toast("发送成功");
            }
          })
          .catch((err) => {});
      }
    },
    getSms(e) {
      // var reg = /^([0-9])\d{10}$/;
      var reg = /^(\d{8,30})$/;
      if (!reg.test(e.phoneNumber)) {
        Toast("请输入正确的手机号码");
        return;
      }
      const TIME_COUNT = 60;
      console.log(this.EditTimer, 253);
      if (!this.EditTimer) {
        this.EditCount = TIME_COUNT;
        this.Editcountdown = false;
        this.EditText = "重新发送";
        this.EditTimer = setInterval(() => {
          if (this.EditCount > 0 && this.EditCount <= TIME_COUNT) {
            this.EditCount--;
          } else {
            this.Editcountdown = true;
            clearInterval(this.EditTimer);
            this.EditTimer = null;
          }
        }, 1000);
        service
          .code({
            phoneNumber: e.phoneNumber,
            code: "",
          })
          .then((res) => {
            if (res.statusCode == 200) {
              Toast("发送成功");
            }
          })
          .catch((err) => {
            Toast(err);
          });
      }
    },
    onPhoneNumberClick() {
      if (
        this.userInfo.phoneNumber !== "" &&
        this.userInfo.phoneNumber !== null
      ) {
        this.phoneShow = false;
      } else {
        this.phoneShow = true;
      }
    },
    // onShareCode() {
    //   if (this.userInfo.shareCode !== "" && this.userInfo.shareCode !== null) {
    //     this.codeShow = false;
    //   } else {
    //     this.codeShow = true;
    //   }
    // },
    // 清除input里面的内容
    // clearInput() {
    //   var Edit = {
    //     phoneNumber: "",
    //     sms: ""
    //   };
    //   this.Edituser = Edit;
    // },
    onEditCancel() {
      var Edit = {
        phoneNumber: "",
        sms: "",
      };
      this.Edituser = Edit;
    },
    // 换绑微信号
    onEditSubmit: function (user) {
      // let redirectUrl = this.$route.query.redirect || "/";
      clearInterval(this.EditTimer);
      this.EditTimer = null;
      this.Editcountdown = true;
      // var reg = /^([0-9])\d{10}$/;
      var reg = /^(\d{8,30})$/;
      if (!reg.test(user.phoneNumber)) {
        Toast("请输入正确的手机号码");
        return;
      }
      // if (user.sms == "") {
      //   Toast("验证码不能为空");
      //   return;
      // }
      // 需要修改换绑手机号
      var Edit = {
        phoneNumber: "",
        // sms: "",
      };
      Dialog.confirm({
        message: "确认是否换绑微信号",
      })
        .then(() => {
          service
            .wxCode({
              phoneNumber: user.phoneNumber,
              // smsCode: user.sms,
              openId: this.userInfo.openId,
            })
            .then((res) => {
              if (res.statusCode == 200) {
                this.Edituser = Edit;
                Toast("操作成功");

                // this.$router.replace("login");
              } else {
                Toast(res.errors);
                //
                if (res.statusCode == 500 && res.errors == "手机号异常") {
                  setTimeout(() => {
                    this.IsIDCard = true;
                  }, 900);
                }
                this.Edituser = Edit;
              }
            })
            .catch((err) => {
              console.log(err, 360);
              if (err == "手机号异常") {
                setTimeout(() => {
                  this.IsIDCard = true;
                }, 900);
              }
              Toast(err);
              this.Edituser = Edit;
            });
        })
        .catch(() => {
          Toast("你已取消");
          this.countdown = true;
          this.text = "发送验证码";
        });
    },
    // 手机号绑定成功
    onSubmit: function (user) {
      clearInterval(this.timer);
      this.timer = null;
      this.countdown = true;
      // var reg = /^(1[0-9])\d{9}$/;
      var reg = /^(\d{8,30})$/;
      var Edit = {
        phoneNumber: "",
        // code: "",
        shareCode: "",
      };
      if (!reg.test(user.phoneNumber)) {
        Toast("请输入正确的电话号码");
        return;
      }
      // if (user.code == "") {
      //   Toast("验证码不能为空");
      //   return;
      // }

      service
        .post({
          phoneNumber: user.phoneNumber,
          // smsCode: user.code,
        })
        .then((res) => {
          if (res.statusCode == 200) {
            this.user = Edit;
            Toast.success("手机号绑定成功");
            this.Refresh();
          }
          // this.$router.replace("page");
        })
        .catch((err) => {
          this.user = Edit;
          Toast(err);
        });
    },
    onIDCardSubmit(EditIDCard) {
      this.IsIDCard = true;
      // var reg = /^(1[0-9])\d{9}$/;
      var reg = /^(\d{8,30})$/;
      // var idcard =
      //   /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      var idcard = /[^0-9Xx]/g;
      if (!reg.test(EditIDCard.phoneNumber)) {
        Toast("请输入正确的手机号码");
      }
      if (!idcard.test(EditIDCard.IDCard)) {
        Toast("身份证格式不正确");
      }

      Dialog.confirm({
        message: "请确认是否换绑",
      })
        .then(() => {
          service
            .IDCard({
              phoneNumber: EditIDCard.phoneNumber,
              idCard: EditIDCard.IDCard,
              openId: this.userInfo.openId,
            })
            .then((res) => {
              if (res.statusCode == 200) {
                Toast("操作成功");
              } else {
                Toast(res.errors);
              }
            })
            .catch((err) => {
              Toast(err);
            });
        })
        .catch(() => {
          Toast("你已取消");
          this.countdown = true;
          this.text = "发送验证码";
        });
    },
    confirm() {
      if (this.user.shareCode == "" || this.user.shareCode == null) {
        Toast("请输入分享码");
        return;
      }
      service.shareCode({ shareCode: this.user.shareCode }).then((res) => {
        this.getCodeNumber();
        if (res.statusCode == 200) {
          this.Refresh();
          Toast("分享码绑定成功");
          setTimeout(() => {
            this.$router.replace({
              name: "user",
              params: {
                IsCode: true,
              },
            });
          }, 500);
        } else {
          Toast(res.errors);
        }
      });
    },
    getCodeNumber() {
      service.codeNum().then((res) => {
        if (res.statusCode == 200) {
          this.getCodeNum = res.data;
        }
      });
    },
    //刷新重新获取登录信息
    Refresh() {
      serviceRefresh
        .wxLoginTest(this.userInfo.openId)
        .then((res) => {
          Toast.success("绑定成功");
          this.wxLogin(res.data).then(() => {
            // this.$router.replace("page");
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style lang="less" scoped>
@deep: ~">>>";
.custom-title {
  margin-right: 47px;
}
// .avarTitle {
//   width: 28px;
// }
.vanGroup {
  padding: 2vw 1vw;

  @{deep}.van-cell__title,
  .van-cell__value {
    flex: none;
  }

  // font-size: 14px;
  // color: #646566;
  // border-bottom: 1px solid #f8f8f8;
}
.cellTitle {
  flex: auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 220px;
}
.cellValue {
  flex: auto;
}
.editNickName {
  .vanNickName {
    padding: 4.26667vw 4.26667vw 0;
    text-align: center;
  }

  .van-cell {
    width: auto;
    padding: 0 4.26667vw;
    height: 40px;
    line-height: 40px;
    margin: 16px 16px 8px;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #f2f2f2;
  }

  .redMess {
    padding-left: 32px;
    font-size: 12px;
    margin-bottom: 16px;
    color: #ee0a24;
  }

  .errMessHeight {
    height: 10.66667vw;
    line-height: 10.66667vw;
    margin-bottom: 4.26667vw;
  }
}
.van-group {
  background-image: url(../../../assets/images/dialogSuccess.png);
  background-repeat: no-repeat;
  width: 100%;
  height: 353.5px;
  background-size: 100% 100%;
}

.overlayContent {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 220px;
  margin-left: -110px;
  text-align: center;
  display: flex;
  flex-direction: column;
  margin-top: 3vw;
}

.overlayCode {
  color: #ee0a24;
  font-size: 22px;
}

.button {
  height: 8vw;
  width: 18vw;
  margin: 6vw auto 3vw;
  font-size: 3.73333vw;
  background: #ee0a24;
}

.close {
  position: absolute;
  top: 40px;
  right: 30px;
  font-size: 20px;
  color: #919191;
}

.reg_active {
  width: 20vw;
  background: linear-gradient(-45deg, #ee0a24, #f96f7f);
  color: #fff;
  border: none;
  font-size: 3vw;
  padding: 0;
  height: 28px;
  line-height: 28px;
}

.van-cell {
  height: 54px;
  line-height: 33px;
}

.reg_disActive {
  // width: 24vw;
  width: 26.8vw;
  color: #323233;
  border: none;
  font-size: 2.4vw;
  height: 28px;
  line-height: 28px;
}
</style>
